import { usePollContext } from '../../../../../Context';
import { getCanSeeManualPollOverlay } from './helpers';

const useManualPollOverlay = () => {
  const { poll } = usePollContext();

  const canSeeOverlay = getCanSeeManualPollOverlay(poll);

  return { canSeeOverlay };
};

export default useManualPollOverlay;
